export const CLOSED = 'CLOSED';
export const TERMINATED = 'TERMINATED';
export const SUSPENDED = 'SUSPENDED';
export const ACTIVE = 'ACTIVE';
